import TransactionHistoryPage from './TransactionHistoryPage';

export default TransactionHistoryPage;
